export default "__VITE_ASSET__b589da23__"